export default __webpack_public_path__ + "static/assets/ba7b3edc2e914270eaa7fe63340e21c3.gif";